

















































































import City from "@/store/entities/city";
import AirlineCompany from "@/store/entities/flight/airlineCompany";
import { Component, Vue } from "vue-property-decorator";
import AddCity from "./modals/addCity.vue";

@Component({
  components: { AddCity },
})
export default class Cities extends Vue {
  search: string = "";
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  cities: City[] = [];

  created() {
    this.getCities();

    (this.headers = [
      { text: "Şehir İsmi", value: "name" },
      { text: "İşlemler", value: "transactions" },
    ]),
      (this.mockData = [
        {
          name: "REDWINGS",
        },
      ]);

    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Tanımlamalar", disabled: true },
      { text: "Şehirler", disabled: true },
    ];
  }

  data() {
    return {
      page: 1,
      pageCount: 0,
    };
  }

  async getCities() {
    await this.$store.dispatch({
      type: "city/getCities",
    });

    this.cities = this.$store.state.city.list;
  }

  editCity(item) {
    this.$store.state.city.editCity = item;
    this.isOpenModal = true;
  }

  openModal() {
    this.$store.state.city.editCity = null;
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.getCities();
  }

  cancelModal() {
    this.isOpenModal = false;
  }
}
